<template>
	<v-container fluid class="ma-0 pa-0">
    <Header />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<CCTVStatusBox class="mt-5" />

      <v-col class="ma-0 pa-0 pb-10" cols="12">
				<v-row class="ma-0 pa-0 mb-2" align="center">
					<v-btn width="9rem" height="50px" class="ma-0 pa-0" 
						id="header_btn" elevation="0" @click="view('cameraList')"
						:class="{'current_btn': currentView === 'cameraList' }">
						{{td('cameraList')}}
					</v-btn>
					<v-btn width="9rem" height="50px" class="ma-0 pa-0" 
						id="header_btn" elevation="0" @click="view('splitScreen')"
						:class="{'current_btn': currentView === 'splitScreen' }">
						{{'分割画面'}}
					</v-btn>
				</v-row>
				<template v-if="currentView == 'cameraList'">
        	<ThumbnailBox />
				</template>
				<template v-else>
					<SplitScreen />
				</template>
      </v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from './components/Header.vue';
import ThumbnailBox from './components/ThumbnailBox.vue';
import CCTVStatusBox from '@/views/dashboard/CCTVStatusBox.vue'
import SplitScreen from './split-screen/SplitScreen.vue';
import rtcViewer from '@/api/webrtc';
import { VideoErrorStatus } from '@/constants';
export default {
	components: {
    Header, ThumbnailBox, CCTVStatusBox, SplitScreen
	},
	mixins: [mixin.common],
	data: () => ({
		authorities: {},
		currentView: 'cameraList',
	}),
  created() {
		this.authorities = this.$store.getters.getAuthorities;
  },
  mounted() {
    console.group('%cUser Data', "font-size:14px;color:#008DD0;");
      // console.log(JSON.parse(sessionStorage.getItem('auth')));
      console.log('%cUser Detail\n', "color:#008DD0;", this.$store.state.userData.user);
			console.log('%cAuthorities\n', "color:#008DD0;", this.$store.getters.getAuthorities);
    console.groupEnd();
		this.checkCameraAuthResult();
		if(this.$route.query.view != undefined) this.currentView = 'splitScreen';
    this.$store.commit('player/SET_PLAYER_ALL_VALUE_DEFAULT');
    setTimeout(() => rtcViewer.removeRTCRemnants(), 1000);
  },
  methods: {
		td(t) {
      return this.$t("lang.dashboard." + t);
    },
		view(screen) {
			this.currentView = screen;
		},
  }
}
</script>

<style lang="scss" scoped>
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__title{
    color: white;
  }
}
#header_btn {
	color: #fff;
	border-bottom: 1px solid #484848;
	background-color: transparent;
	min-width: 1rem;
}
.current_btn {
	color: white !important;
	background-color: transparent;
	min-width: 1rem;
	border-bottom: 4px solid #008DD0 !important;
}
</style>